import { Component, Input } from '@angular/core';
import { ClienteLocalEntrega } from '../../../core/models/clientes/cliente-local-entrega';

/**
 * Conteúdo (corpo) do `<ng-template #locaisEntregaModal let-modal>` do componente pai
 * (pedidos-cadastro.component.html:398-454).
 *
 * Escopo: SOMENTE o `modal-body` (lista de locais de entrega do cliente selecionado,
 * com estados de carregando/erro/vazio). O `<ng-template>`, `#locaisEntregaModal`,
 * `modal-header` (linhas 399-404), `modal-footer` (linhas 451-453) e o método abridor
 * `modalLocaisEntrega(content: any)` (ts:8976) permanecem intocados no pai. Esta é uma
 * modal read-only — sem mutações, sem `@Output()`.
 *
 * Nenhum `@ViewChild` do pai aponta para dentro deste corpo (os 3 `@ViewChild`s existentes
 * — avisoCotaPromocao/comBonificacao/composicao — miram outras modais), portanto não há
 * reconexão necessária.
 */
@Component({
  selector: 'app-pedido-modal-locais-entrega',
  standalone: false,
  templateUrl: './pedido-modal-locais-entrega.component.html',
  styleUrls: ['./pedido-modal-locais-entrega.component.scss']
})
export class PedidoModalLocaisEntregaComponent {
  /* Lista de locais de entrega do cliente selecionado (ts:144: `clienteLocaisEntrega: ClienteLocalEntrega[] = []`). */
  @Input() clienteLocaisEntrega: ClienteLocalEntrega[] = [];
  /* ts:148 */
  @Input() loadingLocalEntrega: boolean = false;
  /* ts:149 */
  @Input() erroLocalEntrega: string | null = null;
}
